import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CompanyState } from "./company.models";
import { SavingStatus } from "../../../shared/models/list.page.model";

export const selectCompanyState = createFeatureSelector<CompanyState>('company');

export const selectLoading = createSelector(
    selectCompanyState,
    (state) => state.loading
)

export const selectCompanies = createSelector(
    selectCompanyState,
    (state) => state.companies
)

export const selectCompaniesTotalCount = createSelector(
    selectCompanyState,
    (state) => state.companiesCount ?? 0
)

export const selectCompaniesPagination = createSelector(
    selectCompanyState,
    (state) => state.companiesPagination
)

export const selectCompanySavingStatus = createSelector(
    selectCompanyState,
    (state) => state.companySaveInProgress ?? SavingStatus.NotStarted
)

export const selectCompanyOverview = createSelector(
    selectCompanyState,
    (state) => state.companyOverview
)

export const selectUsers = createSelector(
    selectCompanyState,
    (state) => state.users
)

export const selectUsersTotalCount = createSelector(
    selectCompanyState,
    (state) => state.usersCount ?? 0
)

export const selectCompanyUsersPagination = createSelector(
    selectCompanyState,
    (state) => state.usersPagination
)

export const selectCompanyUserSavingStatus = createSelector(
    selectCompanyState,
    (state) => state.companyUserSaveInProgress ?? SavingStatus.NotStarted
)

export const selectRoles = createSelector(
    selectCompanyState,
    (state) => state.roles
)

export const selectCompanyUserOverview = createSelector(
    selectCompanyState,
    (state) => state.companyUserOverview
)